<template>
    <div>

        <section class="panel panel--content panel--spaced panel--tight">
            <div class="panel__body" style="padding-bottom: 0 !important;">

                <h3 style="width: 100%;margin: 0;">Total number of sites: {{ sites_array.length }}</h3>
                <h3 style="width: 100%;margin-top: 0;">Sites matching criteria: {{ arrays.site_data.length }}</h3>

                <div style="width:100%;">
                    <div id="site-directory-search-input" class="dataTables_filter" style="display: inline-block;width:50%;margin-top:0;">
                        <label>
                            <input type="search" placeholder="Search site directory" v-model="search_value" v-debounce:600ms="search_sites">
                        </label>
                    </div>
                    <button class="button button--cta button--yellow button--large" @click="export_data" style="display: inline-block;float: right;height: 47px;margin-top: 0;">Export to CSV</button>            
                    <button class="button button--primary text__featured-link" @click="reset_data" style="display: inline-block;float: right;height: 47px;margin: 0 10px 0 0;padding: 7px 25px;">Reset</button>
                </div>

            </div>
        </section>

        <section class="panel panel--content panel--grid-content panel--table">
            <div class="panel__body full-screen-width full-screen-width" style="padding-top:0 !important;overflow-x:scroll;">

                <table class="table table--sortable table--striped table--column-border table--full-screen-width table--full-width sticky--scrollbar dataTable no-footer" style="margin:0;">
                    <thead role="rowgroup">
                        <tr>
                            <th class="sorting">Title<button class="kf-fw indicator" @click="sort_sites('title')"></button></th>
                            <th class="sorting">URL<button class="kf-fw indicator" @click="sort_sites('url')"></button></th>
                            <th class="sorting">Status</th>
                            <th class="sorting">Current project</th>
                            <th class="sorting">Site type</th>
                            <th class="sorting">Division</th>
                            <th class="sorting">Subdivision</th>
                            <th class="sorting">Research Strengths</th>
                            <th class="sorting">Signature Research Themes</th>
                            <th class="sorting">Registered<button class="kf-fw indicator" @click="sort_sites('registered')"></button></th>
                            <th class="sorting">Last updated<button class="kf-fw indicator" @click="sort_sites('last_updated')"></button></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="site in arrays.site_data" :value="site" :key="site">
                            <td>{{ site.title }}</td>
                            <td><a :href="site.url" :title="site.title">{{ trim_domain(site.url) }}</a></td>
                            <td :class="{publicsite : is_site_public(site.status)}">{{ convert_array(site.status) }}</td>
                            <td>{{ site.current_project }}</td>
                            <td>{{ convert_array(site.type) }}</td>
                            <td>{{ convert_array(site.division) }}</td>
                            <td>{{ convert_array(site.subdivision) }}</td>
                            <td>{{ convert_array(site.research_strengths) }}</td>
                            <td>{{ convert_array(site.signature_research_themes) }}</td>
                            <td>{{ convert_date(site.registered) }}</td>
                            <td>{{ convert_date(site.last_updated) }}</td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </section>
                
        <section class="panel panel--content panel--spaced panel--tight">
            <div class="panel__body">

                <div class="alert alert-tertiary">
                    <p><strong>Note</strong></p>
                    <p>The dropdowns are designed to work with each other in filtering the data. If you wish to change the value of any of the dropdowns more than once you will need to reset the tables data using the <strong>Reset</strong> button.</p>
                </div>

            </div>
        </section>

    </div>
</template>

<script>
import mixins from '../mixins.js'

export default {
    props: {
        site_parent_domain: String,
        sites_array: Array,
        divisions_array: Array,
        site_types_array: Array,
        research_strengths_array: Array,
        srt_array: Array
    },
    mixins: [ mixins ],
    data() {
        return {
            arrays: {
                divisions: [],
                site_data: []
            },
            filtering_data: [],
            options: {
                site_status: [
                    'All status',
                    'Public',
                    'Not public',
                    'Archived',
                    'Deleted'
                ]
            },
            search_value: null,
            sorting: {
                column: null,
                order: null,
            }
        }
    },
    watch: {
        selected_division() {
            this.filter_by_division();
        },
        selected_site_status() {
            this.filter_by_status();
        },
    },
    methods: {
        convert_array(array) {
            if(array !== null || array != undefined) {
                return array.join(', ');
            }
        },
        export_data() {
            let site_data = JSON.parse(JSON.stringify(this.arrays.site_data));
            
            for(var i = 0; i < site_data.length; i++) {
                // Swap out commas for spaces
                site_data[i].title = site_data[i].title.replace(/,/g, ' ');
                for(var j = 0; j < site_data[i].division.length; j++) {
                    site_data[i].division[j] = site_data[i].division[j].replace(/,/g, ' ');
                }
                for(var k = 0; k < site_data[i].subdivision.length; k++) {
                    site_data[i].subdivision[k] = site_data[i].subdivision[k].replace(/,/g, ' ');
                }
                for(var l = 0; l < site_data[i].research_strengths.length; l++) {
                    site_data[i].research_strengths[l] = site_data[i].research_strengths[l].replace(/,/g, ' ');
                }
                for(var m = 0; m < site_data[i].signature_research_themes.length; m++) {
                    site_data[i].signature_research_themes[m] = site_data[i].signature_research_themes[m].replace(/,/g, ' ');
                }
                // Join array values into one string
                site_data[i].status = site_data[i].status.join(" - ");
                site_data[i].division = site_data[i].division.join(" - ");
                site_data[i].subdivision = site_data[i].subdivision.join(" - ");
                site_data[i].research_strengths = site_data[i].research_strengths.join(" - ");
                site_data[i].signature_research_themes = site_data[i].signature_research_themes.join(" - ");
            }
            
            const csvString = [
                [
                    'Title',
                    'URL',
                    'Status',
                    'Current project',
                    'Site type',
                    'Division',
                    'Subdivisions',
                    'Research Strengths',
                    'Signature Research Themes',
                    'Registered',
                    'Last updated'
                ],
                ...site_data.map(item => [
                    item.title,
                    item.url,
                    item.status,
                    item.current_project,
                    item.type,
                    item.division,
                    item.subdivision,
                    item.research_strengths,
                    item.signature_research_themes,
                    item.registered,
                    item.last_updated
                ])
            ]
            .map(e => e.join(","))
            .join("\n");
            
            var hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvString);
            hiddenElement.target = '_blank';
            hiddenElement.download = 'Site directory export.csv';
            hiddenElement.click()

        },
        is_site_public(array) {
            if(array.length > 0) {
                return array.includes('Public');
            } else {
                return false;
            }
        },
        reset_data() {
            // Reset our parameters
            this.search_value = null
            this.selected_division = 'All divisions';
            this.selected_site_status = 'All status';
            this.sorting.column = 'title';
            this.sorting.order = 'ASC';
            // Reload the data
            this.arrays.site_data = this.sites_array;
            this.filtering_data = this.sites_array;
        },
        reset_filtered_data() {       
            // If the filtered data array is empty, reload it with our data     
            if(this.filtering_data.length == 0) {
                this.filtering_data = this.arrays.site_data;
            }
        },
        search_sites() {
            // Load the original list data into a local variable
            this.filtering_data = this.arrays.site_data;
            if(this.search_value == null && this.selected_division == 'All divisions' && this.selected_site_status == 'All status') {
                // All default values set, load the full data again
                this.arrays.site_data = this.sites_array;
            } else {            
                // Filter by search value
                if(this.search_value !== null && this.search_value.length > 0 ) {
                    var results = [];
                    this.search_value = this.trim_string(this.search_value);
                    let search_term = this.search_value.toLowerCase();                
                    for(var i = 0; i < this.filtering_data.length; i++) {
                        for(var key in this.filtering_data[i]) {
                            let value = this.filtering_data[i][key];
                            // Need to loop through the keys rather than specifying them
                            if(typeof value === 'string') {
                                if(value.toLowerCase().indexOf(search_term) !== -1) {
                                    if(!this.item_exists(results, this.filtering_data[i])) {
                                        results.push(this.filtering_data[i])
                                    }
                                } 
                            }
                        }
                    }
                    this.filtering_data = results;
                } else {
                    this.filtering_data = this.sites_array;
                }
                // Update our main array
                this.arrays.site_data = this.filtering_data;
            }
            // Now sort the filtered sites data
            this.sort_sites();
        },
        sort_sites(column_name) {
            // Lets set our sorting values before we sort the data
            if(column_name == null || column_name == undefined){
                // If no value has been passed this is the first call upon load
                this.sorting.column = 'title';
                this.sorting.order = 'ASC';
            } else {
                // Value is set, so this has been defined by the click call via the sort button
                this.sorting.column = column_name
                if(this.sorting.order == 'ASC'){
                    this.sorting.order = 'DESC';
                } else {
                    this.sorting.order = 'ASC';
                }
            }
            // Now sort the data by our values
            let orderby = this.sorting.column;
            let order = this.sorting.order;
            this.arrays.site_data.sort(compare);
            // Compare function
            function compare(a, b) {
                // Use toUpperCase() to ignore character casing
                const personA = a[orderby].toUpperCase();
                const personB = b[orderby].toUpperCase();
                // Sort the data
                let comparison = 0;
                if (personA > personB) {
                    comparison = 1;
                } else if (personA < personB) {
                    comparison = -1;
                }
                // Defines the order of the sorted people
                if(order == 'ASC') {
                    return comparison;
                } else {
                    return comparison * -1;
                }
            }

        },
        trim_domain(url) {
            return url.replace(this.site_parent_domain,'./');
        }
    },
    created() {
        // Load data locally
        this.arrays.divisions = this.divisions_array;
        this.arrays.site_data = this.sites_array;

        var no_divisions_obj = {
            name: 'No divisions assigned',
            value: 'No divisions assigned'
        };
        this.arrays.divisions.splice(0, 0, no_divisions_obj);
        // Add in our 'All' values
        var all_divisions_obj = {
            name: 'All divisions',
            value: 'All divisions'
        };
        this.arrays.divisions.splice(0, 0, all_divisions_obj);

        // Now ensure our parameters are reset and lets sort the array
        this.reset_data();
        this.sort_sites();
    },
    beforeDestroy() {
        localStorage.removeItem('site-directory-array');
    }
}
</script>